



$('variant-radios input[type=radio]').on('change', function () {
  var product_form = $(this).closest("form");
  var variantData = JSON.parse($(this).closest("variant-radios").find('.variant-info').html());
  var option1_value = $(this).closest("variant-radios").find("fieldset:nth-of-type(1)").find("input[type=radio]:checked").val();
  var option2_value = $(this).closest("variant-radios").find("fieldset:nth-of-type(2)").find("input[type=radio]:checked").val();
  var option3_value = $(this).closest("variant-radios").find("fieldset:nth-of-type(3)").find("input[type=radio]:checked").val();
  var variant_id = "";
  var price = "";
  // console.log(variantData);
  var variant_radios = $(this).closest("variant-radios").find("fieldset");
  // console.log(variant_radios.length);
  if (variant_radios.length == 3) {
    $.each(variantData, function (index, variant_option) {
      if (variant_option.option1 == option1_value && variant_option.option2 == option2_value && variant_option.option3 == option3_value) {
        variant_id = variant_option.id;
        price = variant_option.price;
        console.log(price);
        return false;
      }
    });
  } else {
    if (option1_value) {
      $.each(variantData, function (index, variant_option) {

        if (variant_option.option1 && !variant_option.option2) {
          if (option1_value == variant_option.option1) {
            variant_id = variant_option.id;
            price = variant_option.price;
            return false;
          }
        }
        if (variant_option.option1 && variant_option.option2) {
          if (option1_value == variant_option.option1 && option2_value == variant_option.option2) {
            variant_id = variant_option.id;
            price = variant_option.price;
            return false;
          }
        }
      });
    }
  }

  product_form.data("variantid", variant_id);
  var product_id = product_form.data("productid");


  var prod_price = price;
  prod_price /= 100;
  product_form.find(".price .price-item").text(prod_price.toLocaleString("en-US", { style: "currency", currency: "USD" }).replace(/[\.,]0{2}/, ''));
  // console.log((prod_price / 4));
  var afterpay_calc = Math.round((prod_price / 4) * 100) / 100;
  $(".after-pay-calc").html("$" + afterpay_calc);
});

function LoadVariantInfo(product_id, variant_id) {
  var params = {
    type: 'POST',
    url: '/products/' + product_id + '.json',
    dataType: 'json',
    success: function (data) {
      console.log(data);
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest.responseJSON);
    }
  };
  jQuery.ajax(params);
}


class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const cartNotification = document.querySelector('cart-notification');
    const variant_id = $(this).find("#buy_buttons_section").closest("form").data('variantid');
    var new_quantity = $(this).find("#buy_buttons_section").closest("form").find("quantity-input .quantity__input").val();
    if (!new_quantity) {
      new_quantity = 1;
    }

    //console.log(new_quantity);
    var properties = {};
    $(this).find("input[name*='properties']").each(function (index, e) {
      properties[$(e).attr("id")] = $(e).val();
    });

    var subscriptions_data = $(this).find("#buy_buttons_section").closest("form").find(".subscription_product-data");
    if (subscriptions_data.length != 0) {
      var sellingPlanId = subscriptions_data.first().data("selected_plan_id");
      cartNotification.addItemToCart(variant_id, "add", "add_sub", properties, new_quantity, sellingPlanId);
      return;
    }


    cartNotification.addItemToCart(variant_id, "add", "", properties, new_quantity);
    return;
    /*
        if(
          $("body").attr("rel") == "choose-your-own-cookies" ||
          $("body").attr("rel") == "custom-cookie-cake"
        ){
    
        }else{
          const cartNotification = document.querySelector('cart-notification');
          const variant_id = $(this).find("#buy_buttons_section").find("input[name=id]").data('variantid');	
          var new_quantity = $(this).find(".quantity__input").val();
          console.log(variant_id);
          cartNotification.addItemToCart(variant_id, new_quantity);
          return;
        }
       
        const cartNotification = document.querySelector('cart-notification');
        const variant_id = $(this).find("#buy_buttons_section").find("input[name=id]").data('variantid');	
        var new_quantity = $(this).find(".quantity__input").val();
        console.log(variant_id);
        cartNotification.addItemToCart(variant_id, new_quantity);
        return;
     */

    this.cartNotification.setActiveElement(document.activeElement);
    const submitButton = this.querySelector('[type="submit"]');
    /*
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
*/

    var properties = {};
    $(this).find("input[name*='properties']").each(function (index, e) {
      properties[$(e).attr("id")] = $(e).val();
    });

    const body = JSON.stringify({
      properties: properties,
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });



    //const variant_id = $(this).find("#buy_buttons_section").find("input[name=id]").data('variantid');	
    //var new_quantity = 1;
    //cartNotification.addItemToCart(variant_id, "add", "", properties);
    /*
    console.log(variant_id);
    console.log(new_quantity);
    console.log(properties);
    */

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });

  }
}

customElements.define('product-form', ProductForm);